import { Col, Row } from "antd";
import eventImg1 from "../../../assets/eventHistory.png";
import eventImg2 from "../../../assets/eventHistory2.png";
import { TextComponent } from "../../../components";
import styles from "./EventHistory.module.css";
import { useLocation, useNavigate } from "react-router-dom";
import useWindowDimensions from "../../../hooks/useWindowDimensions";
import { roles } from "../../../config/roles";
import galleryImg2 from "../../../assets/staticImages/vendorimg4.png";
import galleryImg1 from "../../../assets/staticImages/vendorimg6.png";
import galleryImg3 from "../../../assets/staticImages/wImg.png";
import dummyImage from "../../../assets/imageplace.jpg";
import {
  LocIcon,
  ClockIcon,
  CalendarIcon,
  UserIcon,
} from "../../../components/icons/Icons";
import Storage from "../../../utills/AsyncStorage";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { PhotosMiddleware } from "../../../Store/Middlewares/PhotosMiddleware";
import { useEffect } from "react";

const addCalendarIcon = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M21.0606 21.0371V18.6458H23.4519V21.0371H25.8432V23.4284H23.4519V25.8198H21.0606V23.4284H18.6693V21.0371H21.0606ZM3.12569 7.88489H22.2562V4.29791H19.8649V5.49357H17.4736V4.29791H7.90833V5.49357H5.51701V4.29791H3.12569V7.88489ZM3.12569 10.2762V22.2328H15.0823V24.6241H3.12569C1.805 24.6241 0.734375 23.5535 0.734375 22.2328V4.29791C0.734375 2.97722 1.805 1.9066 3.12569 1.9066H5.51701V0.710938H7.90833V1.9066H17.4736V0.710938H19.8649V1.9066H22.2562C23.5769 1.9066 24.6475 2.97722 24.6475 4.29791V15.0588H22.2562V10.2762H3.12569Z"
      fill="white"
    />
  </svg>
);

const userIconBtn = (
  <svg
    width={20}
    height={20}
    viewBox="0 0 38 38"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.0317 37.9715C14.0432 37.9715 9.25906 35.9899 5.73169 32.4625C2.20431 28.9351 0.222656 24.151 0.222656 19.1625C0.222656 14.1741 2.20431 9.38992 5.73169 5.86255C9.25906 2.33517 14.0432 0.353516 19.0317 0.353516C24.0201 0.353516 28.8043 2.33517 32.3317 5.86255C35.859 9.38992 37.8407 14.1741 37.8407 19.1625C37.8407 24.151 35.859 28.9351 32.3317 32.4625C28.8043 35.9899 24.0201 37.9715 19.0317 37.9715ZM19.0317 34.2097C23.0224 34.2097 26.8498 32.6244 29.6717 29.8025C32.4936 26.9806 34.0789 23.1533 34.0789 19.1625C34.0789 15.1718 32.4936 11.3444 29.6717 8.52255C26.8498 5.70065 23.0224 4.11532 19.0317 4.11532C15.0409 4.11532 11.2136 5.70065 8.39169 8.52255C5.56979 11.3444 3.98446 15.1718 3.98446 19.1625C3.98446 23.1533 5.56979 26.9806 8.39169 29.8025C11.2136 32.6244 15.0409 34.2097 19.0317 34.2097Z"
      fill="#fff"
    />
    <path
      d="M24.2812 13.2731C24.279 16.1698 21.9212 18.5227 19.0244 18.5194C16.1286 18.5161 13.7758 16.1556 13.7813 13.2594C13.7867 10.3589 16.1374 8.01258 19.0381 8.01367C21.9327 8.01422 24.2839 10.3726 24.2812 13.2731Z"
      fill="#fff"
    />
    <path
      d="M27.7056 27.5405C27.702 30.0929 23.8068 32.1661 19.0212 32.1632C14.2373 32.1604 10.3503 30.0804 10.3594 27.5285C10.3684 24.9727 14.2518 22.9053 19.0438 22.9063C23.8259 22.9067 27.7101 24.9848 27.7056 27.5405Z"
      fill="#fff"
    />
  </svg>
);

const images = [galleryImg1, galleryImg2, galleryImg3];

const Gallery = () => {
  const AllPhotos = useSelector((state) => state.PhotosReducer.MyPhotosList);
  console.log("AlbumData", AllPhotos);

  const { state } = useLocation();

  // const navigation = useNavigate();
  const dispatch = useDispatch();
  useEffect(() => {
    getAlbumData();
  }, []);

  const getAlbumData = () => {
    let data = {
      event_id: state?.eventData?.id,
      search: undefined,
      next_page_url: undefined,
    };
    dispatch(PhotosMiddleware.getMyPhotos(data));
  };
  // const onPressRenderMoreContent = () => {
  //   let data = {
  //     event_id: state?.item?.event_id,
  //     user_id: state?.item?.user_id,
  //     next_page_url: AlbumPagination?.links?.next,
  //   };
  //   dispatch(PhotosMiddleware.getAlbumPhotos(data));
  // };
  return (
    <Col lg={12}>
      <Row>
        <TextComponent textClass={styles.statsTitle}>Gallery</TextComponent>
      </Row>
      <Row gutter={[8, 16]} className={styles.imgRow}>
        {AllPhotos.map((img) => (
          <Col xs={24} sm={8}>
            <img
              src={img?.files}
              alt="Gallery Picture"
              style={{
                width: "100%",
                height: "200px",
                objectFit: "cover",
                objectPosition: "center",
                borderRadius: "20px",
              }}
            />
          </Col>
        ))}
      </Row>
    </Col>
  );
};

const EventHistory = () => {
  const navigate = useNavigate();
  const { height, width } = useWindowDimensions();
  // const role = localStorage.getItem("role");
  const role = Storage.getERole("@role");
  // const EventDetails = useSelector((state) => state.EventReducer.EventDetails);

  const EventDetails = useLocation().state?.eventData;

  const isGuest = role == roles.guest;

  console.log(EventDetails);

  const details = [
    {
      title: "Location:",
      icon: <LocIcon size={30} />,
      value: "Los Angeles, California",
    },

    {
      title: "Date:",
      icon: <CalendarIcon size={30} />,
      value: "February 5, 2023",
      rightIcon: role == roles.client && addCalendarIcon,
      rightIconPress: "/events/calendar",
      headerTitle: "Calendar",
    },
    { title: "Start Time:", icon: <ClockIcon size={30} />, value: "10:15 am" },
    { title: "End Time:", icon: <ClockIcon size={30} />, value: "02:15 pm" },
    role !== roles.vendor
      ? {
          title: "Guests:",
          icon: <UserIcon size={30} />,
          value: "04/24",
          rightIcon: role == roles.client && userIconBtn,
          rightIconPress: "/events/eventDetail/guests",
        }
      : {
          title: "Client Name:",
          icon: <UserIcon size={30} />,
          value: "James",
        },
  ];

  return (
    <>
      <Row className={styles.mainRow}>
        <Col lg={10} xl={8}>
          <img
            src={EventDetails?.image ? EventDetails?.image : dummyImage}
            alt=""
            className={styles.eventImage}
          />
        </Col>
        <Col lg={14} xl={16} className={styles.rightCol}>
          <Row className={styles.textRow}>
            <Col>
              <TextComponent textClass={styles.tag}>Past</TextComponent>
              <TextComponent textClass={`${styles.tag} ${styles.color}`}>
                {EventDetails?.category?.name}
              </TextComponent>
            </Col>
            <Col>
              <TextComponent textClass={styles.mainTitle}>
                {EventDetails?.name}
              </TextComponent>
            </Col>
            <Col>
              <TextComponent textClass={styles.desc}>
                {EventDetails?.description}
              </TextComponent>
            </Col>
          </Row>
        </Col>
      </Row>
      <Row>
        <Col lg={isGuest ? 12 : 24} className={styles.statsCol}>
          <Row>
            <TextComponent textClass={styles.statsTitle}>
              Event Details
            </TextComponent>
          </Row>
          <Row>
            <Col xs={24} lg={isGuest ? 24 : 12}>
              <Row className={styles.detailRow}>
                <Col xs={24} sm={10} lg={9} className={styles.leftDetailCol}>
                  <LocIcon size={30} />
                  <TextComponent textClass={styles.detailTitle}>
                    Location:
                  </TextComponent>
                </Col>
                <Col
                  xs={24}
                  sm={11}
                  lg={12}
                  xl={11}
                  className={styles.detailValue}
                >
                  <TextComponent>{EventDetails?.address}</TextComponent>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row>
            {/* {details.slice(1).map((detail) => (
              <Col xs={24} lg={isGuest ? 24 : 12}>
                <Row className={styles.detailRow}>
                  <Col xs={24} sm={10} lg={9} className={styles.leftDetailCol}>
                    {detail.icon}
                    <TextComponent textClass={styles.detailTitle}>
                      {detail.title}
                    </TextComponent>
                  </Col>
                  <Col
                    xs={24}
                    sm={11}
                    lg={12}
                    xl={11}
                    className={styles.detailValue}
                  >
                    <TextComponent>{detail.value}</TextComponent>
                  </Col>
                  {detail.rightIcon && (
                    <Col>
                      <div
                        className={styles.iconBtn}
                        onClick={() =>
                          navigate(detail.rightIconPress, {
                            state: detail.headerTitle && {
                              headrTitle: detail.headerTitle,
                            },
                          })
                        }
                      >
                        {detail.rightIcon}
                      </div>
                    </Col>
                  )}
                </Row>
              </Col>
            ))} */}
            <Col xs={24} lg={isGuest ? 24 : 12}>
              <Row className={styles.detailRow}>
                <Col xs={24} sm={10} lg={9} className={styles.leftDetailCol}>
                  <CalendarIcon size={30} />
                  <TextComponent textClass={styles.detailTitle}>
                    Date:
                  </TextComponent>
                </Col>
                <Col
                  xs={24}
                  sm={11}
                  lg={12}
                  xl={11}
                  className={styles.detailValue}
                >
                  <TextComponent>
                    {moment(EventDetails?.date).format("LL")}
                  </TextComponent>
                </Col>
                {/* {role == roles.client && (
                  <Col>
                    <div
                      className={styles.iconBtn}
                      onClick={() =>
                        navigate("/events/calendar", {
                          state: {
                            headrTitle: "Calendar",
                          },
                        })
                      }
                    >
                      {addCalendarIcon}
                    </div>
                  </Col>
                )} */}
              </Row>
            </Col>
            <Col xs={24} lg={isGuest ? 24 : 12}>
              <Row className={styles.detailRow}>
                <Col xs={24} sm={10} lg={9} className={styles.leftDetailCol}>
                  <ClockIcon size={30} />
                  <TextComponent textClass={styles.detailTitle}>
                    Start Time:
                  </TextComponent>
                </Col>
                <Col
                  xs={24}
                  sm={11}
                  lg={12}
                  xl={11}
                  className={styles.detailValue}
                >
                  <TextComponent>
                    {moment(EventDetails?.start_time).format("hh:mm A")}
                  </TextComponent>
                </Col>
              </Row>
            </Col>
            <Col xs={24} lg={isGuest ? 24 : 12}>
              <Row className={styles.detailRow}>
                <Col xs={24} sm={10} lg={9} className={styles.leftDetailCol}>
                  <ClockIcon size={30} />
                  <TextComponent textClass={styles.detailTitle}>
                    End Time:
                  </TextComponent>
                </Col>
                <Col
                  xs={24}
                  sm={11}
                  lg={12}
                  xl={11}
                  className={styles.detailValue}
                >
                  <TextComponent>
                    {moment(EventDetails?.end_time).format("hh:mm A")}
                  </TextComponent>
                </Col>
              </Row>
            </Col>
            {role !== roles.vendor ? (
              <Col xs={24} lg={isGuest ? 24 : 12}>
                <Row className={styles.detailRow}>
                  <Col xs={24} sm={10} lg={9} className={styles.leftDetailCol}>
                    <UserIcon size={30} />
                    <TextComponent textClass={styles.detailTitle}>
                      Guests:
                    </TextComponent>
                  </Col>
                  <Col
                    xs={24}
                    sm={11}
                    lg={12}
                    xl={11}
                    className={styles.detailValue}
                  >
                    <TextComponent>
                      {EventDetails?.no_of_attendee +
                        "/" +
                        EventDetails?.no_of_guest}
                    </TextComponent>
                  </Col>
                  {/* {role == roles.client && (
                    <Col>
                      <div
                        className={styles.iconBtn}
                        onClick={() => navigate("/events/eventDetail/guests")}
                      >
                        {userIconBtn}
                      </div>
                    </Col>
                  )} */}
                </Row>
              </Col>
            ) : (
              <Col xs={24} lg={isGuest ? 24 : 12}>
                <Row className={styles.detailRow}>
                  <Col xs={24} sm={10} lg={9} className={styles.leftDetailCol}>
                    <UserIcon size={30} />
                    <TextComponent textClass={styles.detailTitle}>
                      Client Name:
                    </TextComponent>
                  </Col>
                  <Col
                    xs={24}
                    sm={11}
                    lg={12}
                    xl={11}
                    className={styles.detailValue}
                  >
                    <TextComponent>James</TextComponent>
                  </Col>
                </Row>
              </Col>
            )}
          </Row>
        </Col>
        {role === roles.guest && <Gallery />}
      </Row>
    </>
  );
};

export default EventHistory;
